/* eslint import/no-webpack-loader-syntax: off */
import describe from 'aot-loader!./describe-loader';

export default describe;
